import { Formik, Form, Field, ErrorMessage } from "formik";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setStep, setmultiMemberLLCDataStep3 } from "../../../Reducers/legalTools/multiMemberLLCSlice";
import * as Yup from "yup";

const MultiMemberLLCFormStep3Schema = Yup.object().shape({
  permittedTransfers: Yup.array()
    .of(Yup.boolean())
    .test("atLeastOneChecked", "Please select at least one", (value) =>
      value.some((v) => v === true)
    ),
  otherPermittedTransfers: Yup.string().when("permittedTransfers", {
    is: (permittedTransfers) => permittedTransfers[3] === true,
    then: (schema) => schema.required("This field is required"),
  }),
  toRepurchaseUnits: Yup.array()
    .of(Yup.boolean())
    .test("atLeastOneChecked", "Please select at least one", (value) =>
      value.some((v) => v === true)
    ),
  howRepurchasePriceBeDetermined: Yup.string().required(
    "This field is required"
  ),
  howRepurchasePriceBePaid: Yup.string().required("This field is required"),
  howLongTheRepaymentTerm: Yup.string().when("howRepurchasePriceBePaid", {
    is: (howRepurchasePriceBePaid) =>
      howRepurchasePriceBePaid === "3" || howRepurchasePriceBePaid === "2",
    then: (schema) => schema.required("This field is required"),
  }),
  interestRate: Yup.string().when("howRepurchasePriceBePaid", {
    is: (howRepurchasePriceBePaid) =>
      howRepurchasePriceBePaid === "3" || howRepurchasePriceBePaid === "2",
    then: (schema) => schema.required("This field is required"),
  }),
  otherInterestRate: Yup.string().when("interestRate", {
    is: (interestRate) => interestRate === "2",
    then: (schema) => schema.required("This field is required"),
  }),
  offsetAgainstRepurchasePrice: Yup.string().required("This field is required"),
  preSetDamagesOffset: Yup.string().when("offsetAgainstRepurchasePrice", {
    is: (offsetAgainstRepurchasePrice) =>
      offsetAgainstRepurchasePrice === "true",
    then: (schema) => schema.required("This field is required"),
  }),
});
const MultiMemberLLCFormStep3 = () => {
  const dispatch = useDispatch();
  const multiMemberLLCData = useSelector(
    (state) => state.multiMemberLLC.multiMemberLLCData
  );
  return (
    <>
      <Formik
        initialValues={{
          permittedTransfers: [
            multiMemberLLCData.permittedTransfers[0],
            multiMemberLLCData.permittedTransfers[1],
            multiMemberLLCData.permittedTransfers[2],
            multiMemberLLCData.permittedTransfers[3],
          ],
          toRepurchaseUnits: [
            multiMemberLLCData.toRepurchaseUnits[0],
            multiMemberLLCData.toRepurchaseUnits[1],
            multiMemberLLCData.toRepurchaseUnits[2],
            multiMemberLLCData.toRepurchaseUnits[3],
          ],
          /* isEstatePlaningTransfers: false,
          isToHeirsOnDeath: false,
          isWithMemberApproval: false,
          isOtherPermittedTransfers: false, */
          otherPermittedTransfers: multiMemberLLCData.otherPermittedTransfers,
          /* isFromAMemberWhoHasWithdrawnOrBeenRemoved: false,
          isAnyImproperlyTransferredUnits: false,
          isThatHaveBeenTransferredFollowingTheDeathOfAMember: false,
          isWhenAnyMemberStopsProvidingServicesToTheCompany: false, */
          howRepurchasePriceBeDetermined:
            multiMemberLLCData.howRepurchasePriceBeDetermined,
          howRepurchasePriceBePaid: multiMemberLLCData.howRepurchasePriceBePaid,
          howLongTheRepaymentTerm: multiMemberLLCData.howLongTheRepaymentTerm,
          interestRate: multiMemberLLCData.interestRate,
          otherInterestRate: multiMemberLLCData.otherInterestRate,
          offsetAgainstRepurchasePrice:
            multiMemberLLCData.offsetAgainstRepurchasePrice,
          preSetDamagesOffset: multiMemberLLCData.preSetDamagesOffset,
        }}
        validationSchema={MultiMemberLLCFormStep3Schema}
        onSubmit={(values) => {
          window.scrollTo(0, 0);
          dispatch(setStep(4));
          dispatch(setmultiMemberLLCDataStep3(values));
        }}
      >
        {(formik) => (
          <Form>
            <div className="content-box mt-5">
              <h3 className="text-dark content-title">
                Unit Transfers and Repurchases
              </h3>
              <p>
                <strong>Transfer Restrictions.</strong> It is generally
                advisable in a closely-held company to have a strict prohibition
                against any transfers of units, but possibly allow permitted
                transfers for estate planning or other similar transfers where
                the same person still controls the voting rights of the units.
              </p>
              <div className="mb-3">
                <label className="form-label">
                  Please select all "permitted transfers" you would like to
                  allow as exceptions to the restriction against transfers of
                  Units (select all that you wish to apply):
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="permittedTransfers[0]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Estate planning transfers (e.g. to a trust or other similar
                    entity)
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="permittedTransfers[1]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">To heirs on death</label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="permittedTransfers[2]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    With member approval (subject to the co-member approval
                    requirements)
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="permittedTransfers[3]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">Other </label>
                </div>
                <Field
                  type="text"
                  name="otherPermittedTransfers"
                  className="form-control"
                  disabled={multiMemberLLCData.isSubmitted}
                />
                <ErrorMessage
                  name="permittedTransfers"
                  component="div"
                  style={{ color: "red" }}
                />
                <ErrorMessage
                  name="otherPermittedTransfers"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>Select all that apply.</span>
              </div>
              <p>
                <strong>Company Unit Repurchase Right:</strong> If certain
                circumstances, we recommend that the company have the right (but
                not obligation) to buy-out the units from a member, former
                member, or other person that obtains an interest in any units in
                the LLC. Our operating agreement does not provide for any
                mandatory buy-out of departing members, which we have found can
                create unintended consequences and is not suitable for most
                circumstances.
              </p>
              <p>
                <strong>Note:</strong> If a mandatory buy-out of units from
                departing members is desired, please continue to complete this
                form and schedule a time to discuss with us.
              </p>
              <div className="mb-3">
                <label className="form-label">
                  The company will have the option (but is not required) to
                  repurchase units in the following circumstances (select all
                  you wish to apply):
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="toRepurchaseUnits[0]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    From a member who has withdrawn or been removed
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="toRepurchaseUnits[1]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    Any improperly transferred units (non-permitted transfers)
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="toRepurchaseUnits[2]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    That have been transferred following the death of a member
                    (buying out a deceased member's heirs)
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="toRepurchaseUnits[3]"
                    className="form-check-input"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    When any member stops providing services to the company
                    (e.g. working member or manager){" "}
                  </label>
                </div>
                <ErrorMessage
                  name="toRepurchaseUnits"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  Note that this applies to "vested" units. Consideration should
                  be given to each of these circumstances, particularly the last
                  two, on whether you want to the company to be able to force a
                  buyback of units.
                </span>
              </div>
              <p>
                <strong>Repurchase Price:</strong> By default, the price for
                repurchased units is the fair market value, determined in good
                faith using set procedures and methodology, including formal
                appraisal if the price cannot be agreed. You may elect to pay
                repurchase price over time, which is generally recommended to
                help ensure the company has sufficient funds.
              </p>
              <div className="mb-3">
                <label className="form-label">
                  How should the repurchase price be determined?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="howRepurchasePriceBeDetermined"
                    className="form-check-input"
                    value="1"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Use our default "fair market value" procedures and
                    methodology.
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="howRepurchasePriceBeDetermined"
                    className="form-check-input"
                    value="2"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    Set a formula (you must provide this formula if you select
                    this option).
                  </label>
                </div>
                <ErrorMessage
                  name="howRepurchasePriceBeDetermined"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  Unless you have a preferred pricing formula in mind that is a
                  fair way to value the business and a member units being bought
                  out, we recommend using our default terms that create a
                  framework for negotiating a fair price.
                </span>
              </div>
              <div className="mb-3">
                <label className="form-label">
                  How should the repurchase price be paid?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="howRepurchasePriceBePaid"
                    className="form-check-input"
                    value="1"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Lump sum, paid in full.
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="howRepurchasePriceBePaid"
                    className="form-check-input"
                    value="2"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    At least 20%, then 80% by a promissory note. (recommended)
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="howRepurchasePriceBePaid"
                    className="form-check-input"
                    value="3"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">
                    Full amount by promissory note.
                  </label>
                </div>
                <ErrorMessage
                  name="howRepurchasePriceBePaid"
                  component="div"
                  style={{ color: "red" }}
                />
              </div>
              {(formik.values.howRepurchasePriceBePaid === "3" ||
                formik.values.howRepurchasePriceBePaid === "2") && (
                <div className="mb-3">
                  <label className="form-label">
                    How long should the repayment term (in months or years) of
                    the promissory note be?
                    <span>*</span>
                  </label>
                  <Field
                    type="text"
                    name="howLongTheRepaymentTerm"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="howLongTheRepaymentTerm"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    We recommend 2-4 years. A discussion is recommended for
                    anything longer.
                  </span>
                </div>
              )}
              {(formik.values.howRepurchasePriceBePaid === "3" ||
                formik.values.howRepurchasePriceBePaid === "2") && (
                <div className="mb-3">
                  <label className="form-label">
                    Interest rate
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="interestRate"
                      className="form-check-input"
                      value="1"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Federal funds + 2% (default)
                    </label>
                  </div>
                  <div className="form-check">
                    <Field
                      type="radio"
                      name="interestRate"
                      className="form-check-input"
                      value="2"
                      disabled={multiMemberLLCData.isSubmitted}
                    />
                    <label className="form-check-label">Other</label>
                  </div>
                  <Field
                    type="text"
                    name="otherInterestRate"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="interestRate"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <ErrorMessage
                    name="otherInterestRate"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    The interest rate should be low, but still reasonable.
                  </span>
                </div>
              )}
              <div className="mb-3">
                <label className="form-label">
                  In the case of a removal for cause, do you want to offset
                  against the repurchase price a pre-set % as an estimation of
                  damage caused to the company?
                  <span>*</span>
                </label>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="offsetAgainstRepurchasePrice"
                    className="form-check-input"
                    value="true"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label" for="flexRadioDefault1">
                    Yes
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    name="offsetAgainstRepurchasePrice"
                    className="form-check-input"
                    value="false"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <label className="form-check-label">No</label>
                </div>
                <ErrorMessage
                  name="offsetAgainstRepurchasePrice"
                  component="div"
                  style={{ color: "red" }}
                />
                <span>
                  Damages to the company may be hard to calculate and setting a
                  "liquidated damages" amount can help avoid paying full price
                  when a member's actions have harmed the company. This is not a
                  penalty, which are not allowed in contracts.
                </span>
              </div>

              {formik.values.offsetAgainstRepurchasePrice === "true" && (
                <div className="mb-3">
                  <label className="form-label">
                    What you you like to use for a pre-set damages offset
                    percentage?
                    <span>*</span>
                  </label>
                  <Field
                    type="text"
                    name="preSetDamagesOffset"
                    className="form-control"
                    disabled={multiMemberLLCData.isSubmitted}
                  />
                  <ErrorMessage
                    name="preSetDamagesOffset"
                    component="div"
                    style={{ color: "red" }}
                  />
                  <span>
                    This should not be a penalty but a reasonable estimation of
                    damages. We suggest that between 20-30% is often
                    appropriate.
                  </span>
                </div>
              )}
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn-submit-secondary me-2 rounded pe-3 d-flex align-items-center"
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(setStep(2));
                }}
              >
                <i className="fa-solid fa-arrow-left mx-2"></i>PREVIOUS
              </button>
              <button
                type="submit"
                className="submit-button ps-3 d-flex align-items-center"
              >
                NEXT<i className="ms-2 fa-solid fa-arrow-right "></i>
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
export default MultiMemberLLCFormStep3;
